module.exports = __webpack_public_path__ + "img/PG1_1-5-259x195.4c467836.png";